import { render, staticRenderFns } from "./DeliverySucessoView.vue?vue&type=template&id=6e829cb3&scoped=true&"
import script from "./DeliverySucessoView.vue?vue&type=script&lang=js&"
export * from "./DeliverySucessoView.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySucessoView.vue?vue&type=style&index=0&id=6e829cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e829cb3",
  null
  
)

export default component.exports